var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCliente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_487_2996)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 28C18 22.4768 22.4768 18 28 18C33.5232 18 38 22.4768 38 28C38 33.5221 33.5233 38 28 38C22.4767 38 18 33.5221 18 28ZM28 20C23.5814 20 20 23.5814 20 28C20 30.2224 20.9064 32.2334 22.3698 33.6832C22.6537 33.1145 23.0949 32.5818 23.7086 32.1443C24.7174 31.4251 26.1354 31 27.9905 31C29.863 31 31.2901 31.4266 32.302 32.1525C32.9106 32.5891 33.3471 33.1193 33.6282 33.6852C35.0928 32.2352 36 30.2234 36 28C36 23.5814 32.4186 20 28 20ZM28 36C26.5525 36 25.1948 35.6155 24.0234 34.9432C24.1199 34.5549 24.3695 34.1294 24.8697 33.7728C25.4524 33.3573 26.43 33 27.9905 33C29.5715 33 30.5543 33.3602 31.1363 33.7776C31.6291 34.1312 31.8767 34.5536 31.9733 34.9451C30.8027 35.6162 29.4462 36 28 36ZM26 26C26 24.8953 26.8955 24 28.0004 24C29.105 24 30 24.8949 30 26C30 27.105 29.1049 28 28.0004 28C26.8955 28 26 27.1046 26 26ZM28.0004 22C25.7915 22 24 23.7902 24 26C24 28.2097 25.7914 30 28.0004 30C30.2098 30 32 28.2093 32 26C32 23.7906 30.2098 22 28.0004 22Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_487_2996",
    x1: 0,
    y1: 28,
    x2: 56,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF914C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCliente);
export default __webpack_public_path__ + "static/media/cliente.8c1b99dfbefd1da5c687a212963f4353.svg";
export { ForwardRef as ReactComponent };